import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, getFormValues, isInvalid, isSubmitting } from 'redux-form';
import { compose, withHandlers } from 'recompose';
import Dropzone from 'react-dropzone';


import TicketAttachmentUploadFormSection from './TicketAttachmentUploadFormSection';
import { formProps, fileType } from '../../../propTypes';


const FORM_NAME = 'ticketAttachmentUpload';


export const getTicketAttachmentUploadForm = (state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    invalid: isInvalid(FORM_NAME)(state),
    submitting: isSubmitting(FORM_NAME)(state),
  };
};


const validate = (values, props) => {
  const errors = {};
  if (values.files.length === 0) {
    errors.files = 'Required';
  }
  return errors;
};


const propTypes = exact({
  ...formProps,
  ticketId: PropTypes.number.isRequired,
  files: PropTypes.arrayOf(fileType).isRequired,
  setFiles: PropTypes.func.isRequired,
});


const TicketAttachmentUploadForm = (props) => {
  const {
    handleSubmit,
    files,
    setFiles,
    error,
  } = props;

  const style = {
    height: '200px',
    width: '200px',
    margin: '10px auto',
    textAlign: 'center',
    borderStyle: 'dashed',
    cursor: 'pointer',
  };

  return (
    <form onSubmit={handleSubmit}>
      <Dropzone
        style={style}
        name="attachments"
        onDrop={setFiles}
      >
        <div>
          Click to select files to upload.
        </div>
      </Dropzone>
      <TicketAttachmentUploadFormSection files={files} />
      <label>{error}</label>
    </form>
  );
};


TicketAttachmentUploadForm.propTypes = propTypes;


const withUploadFiles = withHandlers({
  setFiles: (props) => {
    return (files, event) => {
      const { change, reset } = props;
      reset();
      if (files) {
        change('files', files);
      } else {
        change('files', []);
      }
    };
  },
});


const withForm = reduxForm({
  form: FORM_NAME,
  initialValues: { files: [] },
  validate,
});


const mapStateToProps = (state) => {
  return {
    files: formValueSelector(FORM_NAME)(state, 'files'),
  };
};


const mapDispatchToProps = {};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const enhance = compose(
  withForm,
  withRedux,
  withUploadFiles,
);


export default enhance(TicketAttachmentUploadForm);
